<template>
  <a-spin :spinning="computedSession.local === null" tip="Ładowanie danych...">
    <a-row :gutter="16" :style="{
      filter: computedSession.local === null ? 'blur(5px)' : 'none',
    }" justify="start" type="flex">
      <a-col :style="{ minWidth: '280px' }">
        <a-row align="top" type="flex">
          <a-col v-if="qrCode !== undefined" style="text-align: center; float: left">
            <vue-qrcode :color="{ dark: '#001529ff', light: '#ffffffff' }" :quality="1" :value="qrCode" :width="103"/>
          </a-col>
          <a-col style="padding-top: 8px;">
            <p style="text-align: left; margin-top: 0.2em; font-size: 0.8em">
              <strong>IP: </strong>
              <span>{{
                  computedSession.realIp
                      ? computedSession.realIp
                      : computedSession.local
                }}</span><br/>
              <strong>IP lokalne: </strong>
              <span>{{
                  computedSession.local
                      ? computedSession.local
                      : computedSession.host
                }}</span><br/><strong>MAC: </strong><span>{{ computedSession.macAddress }}</span>
              <br/>
              <strong>Przeglądarka: </strong>
              <span>{{ this.session.browser }}</span>
              <br/>
              <strong>Lokalizacja: </strong>
              <span>{{ computedSession.dorm.name }}</span>
            </p>
          </a-col>
        </a-row>
      </a-col>
      <a-col style="text-align: left; padding: 0.5em 0px 5px 1em">
        <PingDevice v-for="service in pings.filter((p) => p.ping != null)" :key="service.name" :name="service.name"
                    :ping="service.ping"/>
      </a-col>
    </a-row>
  </a-spin>
</template>

<script>
import VueQrcode from "vue-qrcode";
import PingDevice from "@/components/network/PingDevice";
import httpClient from "../../utils/httpClient";

export default {
  components: {
    VueQrcode,
    PingDevice,
  },
  props: {
    size: Number,
  },
  data() {
    return {
      session: {
        browser: undefined,
      },
      qrCode: undefined,
      pings: [],
      pingInterval: undefined
    };
  },
  computed: {
    displaySize: function () {
      return this.size !== undefined ? this.size : 12;
    },
    computedSession: function () {
      return this.$store.getters.getUserConnectionDetails;
    },
    computerLocalDevices: function () {
      return this.localDevices;
    },
  },
  mounted() {
    this.session = this.computedSession
    this.session.browser = this.getBrowser();

    var qrBuilder = {
      m: this.session.mac,
      i: this.session.ip,
      b: this.session.browserUuid,
    };

    this.qrCode = btoa(JSON.stringify(qrBuilder));

    this.getPings()
    this.pingInterval = setInterval(() => {
      this.getPings()
    }, 30000);
  },
  destroy() {
    if (this.pingInterval) {
      clearInterval(this.pingInterval);
    }
  },
  methods: {
    getPings() {
      httpClient.get("/utils/pings").then((response) => {
        this.pings = response.pings
      })
    },
    getBrowser() {
      var userAgent = navigator.userAgent;
      var temporaryValue;
      var M =
          userAgent.match(
              /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
          ) || [];
      if (/trident/i.test(M[1])) {
        temporaryValue = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
        return "IE " + (temporaryValue[1] || "");
      }
      if (M[1] === "Chrome") {
        temporaryValue = userAgent.match(/\b(OPR|Edge)\/(\d+)/);
        if (temporaryValue != null)
          return temporaryValue.slice(1).join(" ").replace("OPR", "Opera");
      }
      M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
      if ((temporaryValue = userAgent.match(/version\/(\d+)/i)) != null)
        M.splice(1, 1, temporaryValue[1]);
      return M.join(" ");
    },
  },
};
</script>
